import { Box } from '@mui/material';
import React from 'react';
import { publicAsset } from '@utils/publicAsset';

const Logo = ({ size, className }: { size?: number; className?: string }) => {
  const style = { width: size || '100%', height: 'auto' };
  return (
    <Box sx={style}>
      <img src={publicAsset('/logo-128.png')} alt="Logo" className={className} />
    </Box>
  );
};

export const JotPsychWordmarkLogo = ({
  size,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  const style = { width: size || '100%', height: 'auto' };
  return (
    <img src={publicAsset('/logo-dark.svg')} alt="JotPsych" style={style} className={className} />
  );
};

export default Logo;
